// Keys used with utils/storage and the public deep-link query params.
//
// Kept in a dependency-free module for the same reason as constants/routeKeys.ts:
// these used to live in app/(public)/_layout.tsx, so every hook that needed one
// imported a route file that imports those hooks back -- a require cycle.

export const redirectStringForStore = 'redirect';
export const anonymousRegisterStringForStore = 'anonymousRegister';
export const registrationCodeStringForStore = 'registrationCode';
export const elliTokenStringForStore = 'elliToken';
export const elliRedirectStringForStore = 'elliRedirect';
export const elliTokenUrlParam = 'elli-token';
export const elliRedirectUrlParam = 'elli-redirect';
